import React from 'react';

export const PowertrainFleets = React.lazy(() => import('./PowertrainFleetsContainer'));
